import React from "react";
import { DotLegalDatePicker, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import IncidentLogYesNoAnswerField from "./IncidentLogYesNoAnswerField.tsx";
import { showsDeadlineExtensionDetails } from "./incidentLogDeadlineExtendedVisibility.ts";

export interface IncidentLogDeadlineExtendedFieldProps {
    answer?: YesNoAnswer | null;
    justification?: string;
    dataSubjectInformedDate?: Date | null;
    onAnswerChange: (answer: YesNoAnswer) => void;
    onJustificationChange: (justification: string) => void;
    onDataSubjectInformedDateChange: (date: Date | null) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogDeadlineExtendedField(props: IncidentLogDeadlineExtendedFieldProps) {
    const { translateString, getDateTimePickerLanguage } = useTranslation();

    return (
        <>
            <IncidentLogYesNoAnswerField
                label={translateString("deadlineExtended")}
                answer={props.answer}
                onChange={props.onAnswerChange}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {showsDeadlineExtensionDetails(props.answer, props.isPreview) && (
                <>
                    <DotLegalTextField
                        label={translateString("justification")}
                        value={props.justification ?? ""}
                        debounce
                        multiline
                        rows={3}
                        onChange={props.onJustificationChange}
                        disabled={props.disabled}
                    />
                    <DotLegalDatePicker
                        label={translateString("dataSubjectInformedOfExtensionDate")}
                        value={props.dataSubjectInformedDate ?? null}
                        onChange={props.onDataSubjectInformedDateChange}
                        disabled={props.disabled}
                        language={getDateTimePickerLanguage()}
                    />
                </>
            )}
        </>
    );
}

export default IncidentLogDeadlineExtendedField;
